import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

// Fallback demo data — only used if no real data is passed in.
const DEFAULT_DATA = [
  { name: 'Jan', sales: 32000 },
  { name: 'Feb', sales: 47000 },
  { name: 'Mar', sales: 34000 },
  { name: 'Apr', sales: 40000 },
  { name: 'May', sales: 20000 },
  { name: 'Jun', sales: 38000 },
  { name: 'Jul', sales: 28000 },
  { name: 'Aug', sales: 40000 },
  { name: 'Sep', sales: 36000 },
  { name: 'Oct', sales: 18000 },
  { name: 'Nov', sales: 45000 },
  { name: 'Dec', sales: 32000 }
];

const SalesChart = ({ data }) => {
  const chartData = (data && data.length > 0) ? data : DEFAULT_DATA;

  return (
    <div style={{ width: '100%', height: 320 }}>
      <ResponsiveContainer>
        <AreaChart data={chartData}>
          
          {/* Gradient Fill */}
          <defs>
            <linearGradient id="colorSales" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#4f8cff" stopOpacity={0.4}/>
              <stop offset="95%" stopColor="#4f8cff" stopOpacity={0}/>
            </linearGradient>
          </defs>

          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />

          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#64748b', fontSize: 12 }}
          />

          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: '#64748b', fontSize: 12 }}
          />

          <Tooltip
            contentStyle={{
              borderRadius: '10px',
              border: 'none',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}
            formatter={(value) => [`$${value.toLocaleString()}`, 'Sales']}
          />

          {/* Area + Line */}
          <Area
            type="monotone"
            dataKey="sales"
            stroke="#4f8cff"
            strokeWidth={3}
            fill="url(#colorSales)"
            dot={{ r: 5, fill: '#4f8cff', stroke: '#fff', strokeWidth: 2 }}
            activeDot={{ r: 7 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesChart;